import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import LoaderApply from "../components/CommonComponents/Loader/LoaderApply";
import { checkJobStatus } from "../redux/actions/jobActions";

const CheckAuthAndRedirectJobs = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const role = useSelector((state) => state.auth.user?.role);
  // Canonical jobseeker id is stored at top-level `state.auth.jobseeker_id`.
  // Use the single canonical field to avoid masking data-model inconsistencies.
  const jobSeekerId = useSelector((state) => state.auth.jobseeker_id);
  const [isRedirecting, setIsRedirecting] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const checkJobAndRedirect = async () => {
      try {
        await dispatch(checkJobStatus(jobId));

        const isIncompleteApplicant = token && role === 2 && !jobSeekerId;
        if (token && !isIncompleteApplicant) {
          navigate(`/applicant-dashboard/related-jobs/${jobId}`);
        } else {
          navigate(`/jobs/related-jobs/${jobId}`);
        }
      } catch (err) {
        console.error("Error checking job status:", err);
        setError(true);
      } finally {
        setIsRedirecting(false);
      }
    };

    checkJobAndRedirect();
  }, [token, role, jobSeekerId, jobId, navigate, dispatch]);

  if (isRedirecting) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoaderApply />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h2
            style={{
              fontSize: "1.25rem",
              fontWeight: "600",
              marginBottom: "0.5rem",
            }}
          >
            Something went wrong
          </h2>
          <p style={{ color: "#666" }}>
            Please try refreshing the page or navigate back
          </p>
        </div>
      </div>
    );
  }

  return null;
};

export default CheckAuthAndRedirectJobs;
